import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    async checkInvitationStatus ({state}, invitationId) {
      return (await axios.get(`/public/invitation/${invitationId}`)).data
    },
    async invitationToProject ({rootState}, data) {
      if (!data.project) throw new Error('project id is undefined')
      return (await axios.post('/invitation/project-member', data)).data
    },
    async acceptInvitation ({rootState}, invitation) {
      return (await axios.post('/user/accept-invitation', {invitation})).data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/invitation.js